import authSlice from './authSlice';
import questionSlice from './questionSlice';
import breadcrumbSlice from './breadcrumbSlice';

const slices = { authSlice, questionSlice, breadcrumbSlice };

export default slices;
